(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["away-mode"] && !Shopify.designMode) return;
  try {
    (function () {
    var bar = document.getElementById('h15-away');
    if (!bar) return;
    var note = bar.getAttribute('data-note') || '';
    var perk = bar.getAttribute('data-perk') || '';
    function line() {
      var p = document.createElement('p');
      p.className = 'h15-away-line';
      p.innerHTML = note.replace(/^hand-engraved in colorado · /, '') + (perk ? ' · <b>' + perk + '</b>' : '');
      return p;
    }
    function place() {
      document.querySelectorAll('add-to-cart-component, button[name="checkout"]').forEach(function (el) {
        if (el.closest('product-card, quick-add-component, .quick-add, quick-add-modal, .product-grid')) return;
        var host = el.tagName === 'BUTTON' ? el.parentNode : el;
        if (!host || host.previousElementSibling && host.previousElementSibling.classList.contains('h15-away-line')) return;
        host.parentNode.insertBefore(line(), host);
      });
    }
    place();
    new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
